export const SAVE_TEST_REF_ID = ' SAVE_TEST_REF_ID';
export const SAVE_SELECTED_NEW_RECORDS = 'SAVE_SELECTED_NEW_RECORDS';
export const SAVE_SELECTED_EXACT_RECORDS= 'SAVE_SELECTED_EXACT_RECORDS';
export const SAVE_SELECTED_Partial_RECORDS='SAVE_SELECTED_Partial_RECORDS'
export const SAVE_SELECTED_Fuzzy_RECORDS='SAVE_SELECTED_Fuzzy_RECORDS'
export const BACK_TO_IMPORT='BACK_TO_IMPORT'
export const SAVE_IMPORT='SAVE_IMPORT'
export const SAVE_STORED_PROCEDURES='SAVE_STORED_PROCEDURES'
